var React = require('react');

function Closed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.589844 11.4098L5.16984 6.82983L0.589844 2.23983L1.99984 0.829834L7.99984 6.82983L1.99984 12.8298L0.589844 11.4098Z","fill":"#423D33"}));
}

Closed.defaultProps = {"width":"8","height":"13","viewBox":"0 0 8 13","fill":"none"};

module.exports = Closed;

Closed.default = Closed;
